module.exports = __webpack_public_path__ + "static/media/kr.1b59095f.svg";